<template>
    <div class="card mb-3">
        <div class="card-body">
            <router-link v-if="$store.state.role == 'branches' || $store.state.role == 'admin' || $store.state.role == 'izbank-admin'" :to="{name: 'bankBranches.create'}" class="btn btn-success ml-2">ثبت سفارش کارت هدیه</router-link>
            <router-link v-if="$store.state.role == 'branches' || $store.state.role == 'izbank-admin'" :to="{name: 'bankBranches.charge'}" class="btn btn-primary ml-2">شارژ کارت هدیه</router-link>
            <router-link v-if="$store.state.role == 'branches' || $store.state.role == 'izbank-admin'" :to="{name: 'bankBranches.requests'}" class="btn btn-secondary">لیست درخواست ها</router-link>
            <router-link v-if="$store.state.role == 'branches' || $store.state.role == 'izbank-admin'" :to="{name: 'bankBranches.cardPin'}" class="btn btn-primary mr-2">صدور رمز کارت</router-link>
            <router-link v-if="$store.state.role == 'branches' || $store.state.role == 'izbank-admin'" :to="{name: 'bankBranches.blockUnblock'}" class="btn btn-dark mr-2">درخواست مسدودی / رفع مسدودی کارت</router-link>
            <hr v-if="$store.state.role == 'branches' || $store.state.role == 'admin' || $store.state.role == 'izbank-admin'">
            <Loading v-if="showLoading" />
            <DataTable :columns="columns" :key="dataTableKey" :rows="rows" v-if="rows.length" :count="count" :url="'Branches/Orders/Search'" :operations="['bankBranches',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}]" />
            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
        </div>
    </div>
</template>

<script>
import { getBranchErrorMessage } from "@/utils/branchOrderContract";
export default {
    name: 'Index',
    data(){
        return {
            columns: [
                {
                    title: 'شناسه',
                    field: 'orderId'
                },
                {
                    title: 'مشتری',
                    field: 'customerName'
                },
                {
                    title: 'کد شعبه',
                    field: 'branchCode'
                },
                {
                    title: 'نام شعبه',
                    field: 'branchName'
                },
                {
                    title: 'ثبت کننده',
                    field: 'registeredBy'
                },
                {
                    title: 'موبایل',
                    field: 'mobile'
                },
                {
                    title: 'وضعیت سفارش',
                    field: 'statusTitle'
                },
                {
                    title: 'نوع سفارش',
                    field: 'orderType'
                },
                {
                    title: 'مبلغ',
                    field: 'amount'
                },
                {
                    title: 'تاریخ',
                    field: 'createdAt'
                },
                {
                    title: 'ساعت',
                    field: 'createdAtTime'
                }
            ],
            rows: [],
            showLoading: true,
            deposit: 0,
            count: 0,
            dataTableKey: 0
        }
    },
    methods: {
        showServerErrors(responseData) {
            this.$swal({
                title: 'خطا',
                icon: 'error',
                text: getBranchErrorMessage(responseData),
                confirmButtonText: 'متوجه شدم'
            });
        },
        getData(){
            if(this.$store.state.userData.isOrganization){
                this.$api.get('Organizations/Wallet/Balance').then(({data}) => {
                    if(data.status)
                        this.deposit = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(data.result);
                });
            }
            this.$api.post('Branches/Orders/Search',{page: 1,perPage: 10}).then(({data}) => {
                if(data.status && data.result && Array.isArray(data.result.list)){
                    this.rows = [];
                    data.result.list.map(order => {
                        this.rows.push({
                            ...order,
                            fullName: order.firstName + ' ' + order.lastName,
                            amount: new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(order.amount) + ' ریال'
                        });
                    });
                    this.count = data.result.count;
                    this.rows.operations = ['bankBranches',{single: {class: 'info',title: 'مشاهده',icon: 'ti-eye'}}];
                    this.dataTableKey += 1;
                } else if (!data.showError) this.showServerErrors(data);
            }).catch((error) => {
                this.showServerErrors((error.response && error.response.data) || {});
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>
